
const digest = '8b82a0eb1c43914fb175b8c4e86981b71bea34c4a236537d53a76c7e7459be74';
const classes = {"backdrop":"_backdrop_s5cdx_1","wrapper":"_wrapper_s5cdx_10","child":"_child_s5cdx_21"};
const css = `._backdrop_s5cdx_1 {
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 1999;
  top: 0;
  left: 0;
}

._wrapper_s5cdx_10 {
  position: fixed;
  z-index: 2000;
  padding: 12px 16px;
  background-color: #ffffff;
  border-radius: 15px;
  border: 1px solid #eaedf3;
  box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.1);
  top: 0;
}

._child_s5cdx_21 {
  margin: 6px 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  